module.exports = __webpack_public_path__ + "static/media/hr.24872340.svg";